module.exports = __webpack_public_path__ + "b6a3cebadd6b973d129e21101687539f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/vi.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/vi.svg
// module chunks = 0